<script>
  import Carousel from "svelte-carousel";
  export let images;
  export let maxWidth = "39.25rem";
  export let slideDuration = 8000;
  let carousel;

  const keyupHandler = (e) => {
    const { key } = e;
    if (key === "ArrowRight") {
      carousel.goToNext();
    }
    if (key === "ArrowLeft") {
      carousel.goToPrev();
    }
  };
</script>

<svelte:window on:keyup={keyupHandler} />

<div class="container" style="--max-width:{maxWidth}">
  {#each images as img}
    <link rel="preload" as="image" href={img.src} imagesizes="55rem" />
  {/each}
  <Carousel
    bind:this={carousel}
    arrows
    autoplay
    autoplayDuration={slideDuration}
    autoplayProgressVisible
    pauseOnFocus
    swiping
  >
    {#each images as img}
      <img src={"/images/" + img.src} alt={img.alt} />
    {/each}
  </Carousel>
</div>

<style>
  .container {
    margin: 0 auto;
    width: 98vw;
    max-width: var(--max-width);
  }
  img {
    height: auto;
  }
  @media screen and (min-width: 480px) {
    .container {
      width: calc(98vw - 2rem);
    }
  }
</style>
